const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") return undefined

  const errorRecord = error as Record<string, unknown>
  const responseRecord =
    errorRecord.response && typeof errorRecord.response === "object"
      ? (errorRecord.response as Record<string, unknown>)
      : undefined

  const candidates = [
    errorRecord.status,
    errorRecord.statusCode,
    responseRecord?.status,
    responseRecord?.statusCode,
  ]

  for (const candidate of candidates) {
    if (typeof candidate === "number") return candidate
    if (typeof candidate === "string") {
      const parsedStatus = Number.parseInt(candidate, 10)
      if (!Number.isNaN(parsedStatus)) return parsedStatus
    }
  }

  return undefined
}

const getErrorMessage = (error: unknown): string => {
  if (!error || typeof error !== "object") return ""
  const message = (error as { message?: unknown }).message
  return typeof message === "string" ? message : ""
}

export const shouldRemoveStoredCartForError = (error: unknown): boolean => {
  const status = getErrorStatus(error)
  if (status === 404 || status === 410) return true

  const message = getErrorMessage(error).toLowerCase()
  return message.includes("cart") &&
    (message.includes("not found") || message.includes("does not exist"))
}
